import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, Thumbs, EffectFade, Keyboard } from 'swiper/modules';
import { SWIPER_CONFIG } from '../config/swiper';

const swiperElements = Array.from(document.querySelectorAll('.swiper'));
const swiperInstances = new Map();

const isElementInViewport = (el) => {
    const rect = el.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
};

const initSwiper = (element) => {
    const swiper = new Swiper(element, {
        modules: [Navigation, Pagination, Autoplay, Thumbs, EffectFade, Keyboard],
        ...SWIPER_CONFIG,
        keyboard: {
            enabled: true,
            onlyInViewport: true,
        },
        navigation: {
            nextEl: `#${element.id}-next`,
            prevEl: `#${element.id}-prev`,
            addIcons: false,
        },
        pagination: {
            el: `#${element.id}-pagination`,
            clickable: true,
        },
        ...(JSON.parse(element.dataset?.config || '{}')),
        ...(element.dataset?.thumbs ? {
            thumbs: {
                swiper: initSwiper(document.getElementById(element.dataset.thumbs)),
            },
        } : {}),
    });

    swiper.on('slideChange', () => {
        const allVideos = element.querySelectorAll('.video video');
        allVideos.forEach((video) => {
            if (!video.paused) {
                video.pause();
            }
        });

        const activeSlide = element.querySelector('.swiper-slide-active');
        const activeVideoWrapper = activeSlide?.querySelector('.video[data-autoplay="true"]');
        const activeVideo = activeVideoWrapper?.querySelector('video');

        if (activeVideo && isElementInViewport(element)) {
            activeVideo.play().catch(() => {});
        }
    });

    swiperInstances.set(element.id, swiper);

    return swiper;
};

swiperElements.forEach((element) => {
    const swiper = initSwiper(element);

    if (element.dataset?.thumbs) {
        const thumbsElement = document.getElementById(element.dataset.thumbs);
        const thumbButtons = thumbsElement?.querySelectorAll('.image-wrapper');

        thumbButtons?.forEach((button, index) => {
            button.addEventListener('click', () => {
                swiper.slideTo(index);
            });
        });
    }
});
